// Generated by scripts/gen_node_metas.py from video_model_families.py.
export interface VideoFamily { id: string; label: string; models: readonly string[] }
export const VIDEO_FAMILIES: readonly VideoFamily[] = [
  {
    "id": "video-family/gemini",
    "label": "Gemini",
    "models": [
      "gemini-omni-flash-preview"
    ]
  },
  {
    "id": "video-family/gemini-1.1",
    "label": "Gemini 1.1",
    "models": [
      "gemini-omni-1.1-flash-preview",
      "gemini-omni-1.1-flash-i2v",
      "gemini-omni-1.1-flash-edit",
      "gemini-omni-1.1-flash-extend"
    ]
  },
  {
    "id": "video-family/seedance-2.0",
    "label": "Seedance 2.0",
    "models": [
      "seedance-2.0-reference-to-video-atlas-cloud",
      "seedance-2.0-image-to-video-atlas-cloud",
      "seedance-2.0-reference-to-video",
      "seedance-2.0-image-to-video"
    ]
  },
  {
    "id": "video-family/seedance-2.5",
    "label": "Seedance 2.5",
    "models": [
      "seedance-2.5-reference-to-video-atlas-cloud",
      "seedance-2.5-image-to-video-atlas-cloud",
      "seedance-2.5-first-last-frame-atlas-cloud",
      "seedance-2.5-video-editing-atlas-cloud",
      "seedance-2.5-video-extension-atlas-cloud"
    ]
  },
  {
    "id": "video-family/minimax-h3",
    "label": "Minimax H3",
    "models": [
      "minimax-h3-text-to-video-atlas-cloud",
      "minimax-h3-image-to-video-atlas-cloud",
      "minimax-h3-reference-to-video-atlas-cloud",
      "minimax-h3-reference-to-video",
      "minimax-h3-max-turbo-text-to-video-atlas-cloud",
      "minimax-h3-max-turbo-image-to-video-atlas-cloud",
      "minimax-h3-fast-text-to-video-atlas-cloud",
      "minimax-h3-fast-image-to-video-atlas-cloud",
      "minimax-h3-fast-reference-to-video-atlas-cloud",
      "minimax-h3-reference-to-video-meta-hosted",
      "minimax-h3-image-to-video-meta-hosted"
    ]
  },
  {
    "id": "video-family/mango",
    "label": "Mango",
    "models": [
      "mango-video-text-to-video",
      "mango-video-image-to-video"
    ]
  },
  {
    "id": "video-family/muse",
    "label": "Muse",
    "models": [
      "muse-video-1.0",
      "muse-video-1.0-r2v"
    ]
  },
  {
    "id": "video-family/veo-3.1",
    "label": "Veo 3.1",
    "models": [
      "veo-3.1-generate-preview"
    ]
  }
]
